<script setup lang="ts">
import { useUiStore } from '@/store/uiStore';

const uiStore = useUiStore();
const breadcrumbs = computed(() => {
  const crumbs = uiStore.breadcrumbs.slice();
  crumbs.pop();

  return crumbs;
});
</script>

<template>
  <nav class="app-breadcrumbs">
    <ol>
      <li>
        <router-link to="/" class="item-body">
          <UiIcon name="Home" :size="16" />
        </router-link>
      </li>

      <li v-for="(crumb, i) in breadcrumbs" :key="i" class="item">
        <span class="separator">
          <UiIcon name="ChevronRight" :size="18" />
        </span>

        <router-link :to="crumb.to" class="item-body">
          {{ crumb.caption }}
        </router-link>
      </li>
    </ol>
  </nav>
</template>

<style lang="scss" scoped>
.app-breadcrumbs {
  ol {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    list-style-type: none;

    padding-left: 0;
  }

  li {
    margin: 0;
  }
}

.item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.item-body {
  padding: var(--space-2) var(--space-8);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--border-radius-4);
  height: px(28);
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-medium);

  &.active {
    background-color: var(--color-primary-50);
    color: var(--color-primary-800);
  }
}
a.item-body {
  transition: background-color var(--duration-base) ease-out;
  color: var(--color-gray-600);
  height: px(18);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background-color: var(--color-gray-0);
    transition-duration: 0s;
  }
}

.separator {
  color: var(--color-gray-400);
}

.icon {
  color: var(--color-primary-600);
}
</style>
